// This file was generated using `pay js:run gql-v1 --type=fragment --name=LegalEntityPersonVerificationDocumentArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment LegalEntityPersonVerificationDocumentArkFragment on OpenapiLegalEntityPersonVerificationDocument {
    back {
      id
    }
    details
    details_code
    front {
      id
    }
  }
`;

export const legalEntityPersonVerificationDocumentArkFragment: LegalEntityPersonVerificationDocumentArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type LegalEntityPersonVerificationDocumentArkFragmentData = {
  readonly __typename: 'OpenapiLegalEntityPersonVerificationDocument';
  readonly details: string | null;
  readonly details_code: string | null;
  readonly back: {
    readonly __typename: 'OpenapiFile';
    readonly id: string;
  } | null;
  readonly front: {
    readonly __typename: 'OpenapiFile';
    readonly id: string;
  } | null;
};

export type LegalEntityPersonVerificationDocumentArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const legalEntityPersonVerificationDocumentArkFragmentPermissions = {} as const;

doc.permissions = legalEntityPersonVerificationDocumentArkFragmentPermissions;

export type LegalEntityPersonVerificationDocumentArkFragmentPermissions =
  V1PermissionToken<
    typeof legalEntityPersonVerificationDocumentArkFragmentPermissions
  >;

export type LegalEntityPersonVerificationDocumentArkFragmentDocument =
  GraphQlDocument<
    LegalEntityPersonVerificationDocumentArkFragmentData,
    LegalEntityPersonVerificationDocumentArkFragmentVariables,
    LegalEntityPersonVerificationDocumentArkFragmentPermissions
  >;
